import { UseQueryResult } from '@tanstack/react-query'
import React from 'react'

import { GetCurrentTaxYearQuery, useGetCurrentTaxYearQuery } from '../generated/graphql'
import useAuth from './useAuth'

interface Props {
  setCurrentTaxYear: React.Dispatch<number>
}

const FIFTEEN_MINUTES = 1_000 * 60 * 15

export default function useGetCurrentTaxYear(props: Props): UseQueryResult<GetCurrentTaxYearQuery, unknown> {
  const { authInformation } = useAuth()

  const result = useGetCurrentTaxYearQuery(
    {},
    {
      gcTime: FIFTEEN_MINUTES,
      enabled: Boolean(authInformation && !authInformation.isMasterUser && !authInformation.isMcatUser),
    },
  )

  const currentTaxYear = result.data?.currentTaxYear
  const { setCurrentTaxYear } = props

  React.useEffect(() => {
    if (currentTaxYear !== undefined) {
      setCurrentTaxYear(currentTaxYear)
    }
  }, [currentTaxYear, setCurrentTaxYear])

  return result
}
